var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpcomingicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1557_2199)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.20312 17.3438C7.81481 17.3438 7.5 17.6586 7.5 18.0469V20.625H3.28125V18.0469C3.28125 17.6586 2.96644 17.3438 2.57812 17.3438C2.18981 17.3438 1.875 17.6586 1.875 18.0469V23.2969C1.875 23.6852 2.18981 24 2.57812 24C2.96644 24 3.28125 23.6852 3.28125 23.2969V22.0312H7.5V23.2969C7.5 23.6852 7.81481 24 8.20312 24C8.59144 24 8.90625 23.6852 8.90625 23.2969V18.0469C8.90625 17.6586 8.59144 17.3438 8.20312 17.3438Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.20312 17.3438C7.81481 17.3438 7.5 17.6586 7.5 18.0469V20.625H5.39062V22.0312H7.5V23.2969C7.5 23.6852 7.81481 24 8.20312 24C8.59144 24 8.90625 23.6852 8.90625 23.2969V18.0469C8.90625 17.6586 8.59144 17.3438 8.20312 17.3438Z",
    fill: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.84375 18.75H2.57812C1.15425 18.75 0 17.5957 0 16.1719V7.96875C0 7.19208 0.629578 6.5625 1.40625 6.5625C2.18292 6.5625 2.8125 7.19208 2.8125 7.96875V15.9375H9.84375C10.6204 15.9375 11.25 16.5671 11.25 17.3438C11.25 18.1204 10.6204 18.75 9.84375 18.75Z",
    fill: "#0A617D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.84375 15.9375H5.39062V18.75H9.84375C10.6204 18.75 11.25 18.1204 11.25 17.3438C11.25 16.5671 10.6204 15.9375 9.84375 15.9375Z",
    fill: "#05303D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0781 9.14062C21.4081 9.14062 23.2969 7.25183 23.2969 4.92188C23.2969 2.59192 21.4081 0.703125 19.0781 0.703125C16.7482 0.703125 14.8594 2.59192 14.8594 4.92188C14.8594 7.25183 16.7482 9.14062 19.0781 9.14062Z",
    fill: "#E2DFF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0781 9.84375C16.3642 9.84375 14.1562 7.6358 14.1562 4.92188C14.1562 2.20795 16.3642 0 19.0781 0C21.792 0 24 2.20795 24 4.92188C24 7.6358 21.792 9.84375 19.0781 9.84375ZM19.0781 1.40625C17.1396 1.40625 15.5625 2.98336 15.5625 4.92188C15.5625 6.86039 17.1396 8.4375 19.0781 8.4375C21.0166 8.4375 22.5938 6.86039 22.5938 4.92188C22.5938 2.98336 21.0166 1.40625 19.0781 1.40625Z",
    fill: "#51316E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0781 5.625H17.6719C17.2836 5.625 16.9688 5.31019 16.9688 4.92188C16.9688 4.53356 17.2836 4.21875 17.6719 4.21875H18.375V3.51562C18.375 3.12731 18.6898 2.8125 19.0781 2.8125C19.4664 2.8125 19.7812 3.12731 19.7812 3.51562V4.92188C19.7812 5.31019 19.4664 5.625 19.0781 5.625Z",
    fill: "#0A617D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0781 2.8125V5.625C19.4664 5.625 19.7812 5.31019 19.7812 4.92188V3.51562C19.7812 3.12731 19.4664 2.8125 19.0781 2.8125Z",
    fill: "#05303D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4844 24C10.5783 24 9.84375 23.2655 9.84375 22.3594V15.9375H5.39062C3.96675 15.9375 2.8125 14.7832 2.8125 13.3594V7.26562C2.8125 5.84175 3.96675 4.6875 5.39062 4.6875C6.8145 4.6875 7.96875 5.84175 7.96875 7.26562V12.6562H9.84375C11.6559 12.6562 13.125 14.1253 13.125 15.9375V22.3594C13.125 23.2655 12.3905 24 11.4844 24Z",
    fill: "#F69D9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4844 24C12.3905 24 13.125 23.2655 13.125 22.3594V15.9375C13.125 14.1253 11.6559 12.6562 9.84375 12.6562H7.96875V7.26562C7.96875 5.84175 6.8145 4.6875 5.39062 4.6875V15.9375H9.84375V22.3594C9.84375 23.2655 10.5783 24 11.4844 24Z",
    fill: "#EE5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.85938 5.39062C4.37316 5.39062 3.16406 4.18148 3.16406 2.69531C3.16406 1.20914 4.37316 0 5.85938 0C7.34559 0 8.55469 1.20914 8.55469 2.69531C8.55469 4.18148 7.34559 5.39062 5.85938 5.39062Z",
    fill: "#F5B79C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1557_2199"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpcomingicon);
export default __webpack_public_path__ + "static/media/upcomingicon.659f8f5497c31f76b10058361dbed911.svg";
export { ForwardRef as ReactComponent };